import { useEffect } from 'react';
import { useModule } from '../hooks/data.js';
import { useToast } from '../state/toast.jsx';
import { beantragteModule, vergissBeantragt } from './zustand.js';

/**
 * Meldet einmal «… ist jetzt aktiv», wenn ein auf diesem Gerät beantragtes Modul freigeschaltet wurde.
 * Fragt die API nur, solange eine Anfrage offen ist.
 */
export function ModulHinweis() {
  const offen = beantragteModule();
  const q = useModule({ laden: offen.length > 0 });
  const toast = useToast();
  useEffect(() => {
    if (!q.data) return;
    const ids = beantragteModule();
    const fertig = q.data.module.filter((x) => ids.includes(x.id) && x.zustand !== 'beantragt');
    if (!fertig.length) return;
    vergissBeantragt(fertig.map((x) => x.id));
    for (const x of fertig.filter((y) => y.zustand === 'an')) toast({ text: `${x.titel} ist jetzt aktiv`, long: true });
  }, [q.data, toast]);
  return null;
}
